import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import { Footer } from "../components/Footer";
import { site } from "../content";

export default function PrivacyPage() {
  const { privacy } = site;

  useEffect(() => {
    document.title = "Tietosuojaseloste | By Milja V";
    return () => {
      document.title = "By Milja V – Sisällöntuotanto ja someapu | Kangasala & Tampere";
    };
  }, []);

  return (
    <div data-testid="privacy-page">
      <header className="border-b border-[#EFE6DC]">
        <div className="max-w-3xl mx-auto px-6 pt-28 pb-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#4A6572] hover:text-[#2B2724] transition-colors duration-200"
            data-testid="privacy-back-link"
          >
            <ArrowLeft size={16} /> {privacy.back}
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16 md:py-20">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#4A6572]">{privacy.updated}</p>
          <h1 className="mt-4 font-serif font-light text-4xl md:text-5xl tracking-tight text-[#2B2724]">
            {privacy.title}
          </h1>
        </Reveal>
        <div className="mt-12 space-y-12">
          {privacy.sections.map((s, i) => (
            <Reveal key={s.heading} delay={i * 0.05}>
              <section data-testid={`privacy-section-${i + 1}`}>
                <h2 className="font-serif text-2xl text-[#2B2724]">{s.heading}</h2>
                <div className="mt-4 space-y-4 text-base leading-relaxed text-[#5C564F]">
                  {s.paragraphs.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                </div>
              </section>
            </Reveal>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
